// extracted by mini-css-extract-plugin
export default {"btns":"styles_btns__kbYIA","btns3":"styles_btns3__5ryVQ","btnSalesforce":"styles_btn-salesforce__vTgFm","btnAzure":"styles_btn-azure__sTBd7","btnHubspot":"styles_btn-hubspot__pHGFi"};